<template>
	<div class="globalKPIContainer" ref="zoneRef">
		<div v-for="kpiParam in activeKpiParams" :key="`${deliveryLocationId}-${kpiParam.reference}`">
			<Kpi :title="kpiParam.kpiId ? kpiParam.reference : t(kpiParam.reference)" :params="buildKpiParams(kpiParam)" :version="contextVersion" />
		</div>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import Kpi from './Kpi.vue';
import { useTranslator } from '@/utils/useTranslator';

const t = useTranslator();
const zoneRef = ref(null);
const deliveryLocationId = ref(null);
const kpiParams = ref([]);
const appointment = ref(null);
const contextVersion = ref(0);

let _mountTarget = null;

const activeKpiParams = computed(() => kpiParams.value.filter(Boolean));

function buildKpiParams(kpiParam) {
	return {
		...kpiParam,
		deliveryLocationIds: deliveryLocationId.value != null ? [deliveryLocationId.value] : null,
		localAppointments: appointment.value ? [appointment.value] : null,
	};
}

function handleContextChange(event) {
	const { deliveryLocationId: dlId, kpiParams: params, appointment: apt } = event.detail;
	deliveryLocationId.value = dlId;
	kpiParams.value = params || [];
	appointment.value = apt || null;
	contextVersion.value++;
}

onMounted(() => {
	// The event is dispatched on #vue-kpi-statement-zone (the mount target = our parentElement).
	// DOM events bubble UP so we must listen on the parent, not on zoneRef (a child).
	_mountTarget = zoneRef.value?.parentElement;
	_mountTarget?.addEventListener('vue:kpi-context', handleContextChange);

	// Handle the case where the event fired before Vue mounted (timing race).
	if (_mountTarget?._pendingKpiContext) {
		handleContextChange({ detail: _mountTarget._pendingKpiContext });
	}
});

onBeforeUnmount(() => {
	_mountTarget?.removeEventListener('vue:kpi-context', handleContextChange);
	_mountTarget = null;
});
</script>
